import { useSelector } from "react-redux";
import { CheckPermissions } from '../../../logic/Admin/Permissions/CheckPermission/CheckPermissions';
import { selectUserData } from '../../../features/userSlice';
import Page404 from '../../../components/Page404/Page403';
import ActivityNotes from '../../../components/AssetManagement/ActivityNotes/ActivityNotes';


const BusinessActivityNotesScreen = () => {
  const response = useSelector(selectUserData);
  const hasViewActivityNotesPermission = CheckPermissions(
    response?.data?.products?.assets,
    "overview",
    "view_activity_notes"
  );
  return (
    <>
      {hasViewActivityNotesPermission ? (
        <ActivityNotes />
      ) : (
        <Page404 />
      )}
    </>
  )
}

export default BusinessActivityNotesScreen
